import React from 'react';

import { Navigate, useRoutes } from 'react-router-dom';

import { AbilityContextProvider } from '@/contexts/ability';
import { SettingsContextProvider } from '@/contexts/settings';
import { WorkspaceContextProvider } from '@/contexts/workspace';
import { NotificationsContextProvider } from '@/contexts/notifications';
import { SystemNotificationsProvider } from '@/contexts/systemNotifications';

import {
  APP_ROUTES,
} from '@/assets/MenuItems';

import { PUBLIC_ROUTES } from '@/views/public/routes';
import { NotFoundPage } from '@/views/public/NotFoundPage';
import { WithOwnershipProvider } from '@/views/common/WithOwnership/context';

import { DashboardLayout } from '@/layouts/Dashboard';
import { AuthenticatedLayout } from '@/layouts/Authenticated';
import { NotAuthenticatedLayout } from '@/layouts/NotAuthenticated';
import { SidebarConfigProvider } from '@/features/sidebar/SidebarConfigContext';

const Routes = () => useRoutes([
  {
    element: <NotAuthenticatedLayout />,
    children: [
      ...PUBLIC_ROUTES,
    ],
  },
  {
    element: (
      <WorkspaceContextProvider>
        <AbilityContextProvider>
          <WithOwnershipProvider>
            <SettingsContextProvider>
              <NotificationsContextProvider>
                <SystemNotificationsProvider>
                  <SidebarConfigProvider>
                    <AuthenticatedLayout />
                  </SidebarConfigProvider>
                </SystemNotificationsProvider>
              </NotificationsContextProvider>
            </SettingsContextProvider>
          </WithOwnershipProvider>
        </AbilityContextProvider>
      </WorkspaceContextProvider>
    ),
    children: [
      {
        path: '/:workspace',
        element: <DashboardLayout />,
        children: [...APP_ROUTES],
      },
      {
        path: '/',
        element: <DashboardLayout />,
      },
    ],
  },
  {
    path: '/404',
    element: <NotFoundPage />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
]);

export default Routes;
